var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15 33.87c-.86 0-1.6-.3-2.22-.92A3.04 3.04 0 0 1 6 30.72v-6.63h3.15v6.63h21.13v-6.63h3.12v6.63c0 .87-.31 1.6-.93 2.23a3 3 0 0 1-2.19.92H9.15Zm9-7.57V12.03l-4.58 4.61-2.25-2.24 8.4-8.4 8.4 8.4-2.25 2.24-4.57-4.6V26.3h-3.16Z"
  })));
};
export default SvgUpload;